module.exports = __webpack_public_path__ + "img/banner.76f473f5.jpg";